import React  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { Fragment } from "react";

export default function ContactReferee() {
    
    let app = ApplicantContainer.useContainer();

    let inputContactReferee = app.inStdValues.frContactReferee;

      const addContactReferee = index => {    

        const values = [...inputContactReferee];
        values.splice(index+1, 0, { sname: '', affiliation: '', position: '', email: '' });
       
        app.onChangeInStdValues({...app.inStdValues, frContactReferee:values});
      }

      const delContactReferee = index => {    

        if(inputContactReferee.length === 1) return 0;

        const values = [...inputContactReferee];    
        values.splice(index, 1);

        if(values.length === 1) values[0].highest = true;       

        app.onChangeInStdValues({...app.inStdValues, frContactReferee:values});
      }

      const handleInputChange = (inputname, index, event) => {        
        const values = [...inputContactReferee];  
        
        values[index].[inputname] = event.target.value;    
  
        app.onChangeInStdValues({...app.inStdValues, frContactReferee:values});
      };

    return (
        
    app.showContactReferee ? 
        <>
        <Form.Row className="d-none d-sm-flex ">
          
            <Col xs={12} sm={3} className="table-header d-flex justify-content-center mx-auto">            
            <Form.Group as={Col}>
              <Form.Label>Name</Form.Label>
            </Form.Group>
            </Col>
            <Col xs={12} sm={3} className="table-header d-flex justify-content-center mx-auto">            
            <Form.Group as={Col}>
            <Form.Label>Affiliation</Form.Label>
            </Form.Group>
            </Col>
            <Col xs={12} sm={2} className="table-header d-flex justify-content-center mx-auto">            
            <Form.Group as={Col}>
            <Form.Label>Position</Form.Label>
            </Form.Group>
            </Col>        
            <Col xs={12} sm={2} className="table-header d-flex justify-content-center mx-auto">            
            <Form.Group as={Col}>
            <Form.Label>Email</Form.Label>
            </Form.Group>
            </Col>        
            <Col xs={12} sm={2} className="table-header d-flex justify-content-center">                      
            <Form.Group as={Col} className="segbutton">
            <Form.Label>action</Form.Label>
            </Form.Group>
            </Col>
      </Form.Row> 


        {inputContactReferee.map((inputField, index) => (      
            <Fragment key={`${inputField}~${index}`}>
            <Form.Row >
                <Col xs={12} sm={3}>
                <Form.Group as={Col} controlId="formName[]">
                    <Form.Label className="d-flex d-sm-none">Name</Form.Label>
                    <Form.Control type="text" required name="formName" placeholder="" value={inputField.sname} onChange={event => handleInputChange('sname', index, event)} />
                </Form.Group>
                </Col>
                <Col xs={12} sm={3}>
                <Form.Group as={Col} controlId="formAffiliation[]">
                    <Form.Label className="d-flex d-sm-none">Affiliation</Form.Label>
                    <Form.Control type="text" required name="formAffiliation" placeholder="" value={inputField.affiliation} onChange={event => handleInputChange('affiliation', index, event)} />
                </Form.Group>
                </Col>
                <Col xs={12} sm={2}>
                <Form.Group as={Col} controlId="formPosition[]">
                    <Form.Label className="d-flex d-sm-none">Position</Form.Label>
                    <Form.Control type="text" required name="formPosition" placeholder="" value={inputField.position} onChange={event => handleInputChange('position', index, event)} />
                </Form.Group>
                </Col>
                <Col xs={12} sm={2}>
                <Form.Group as={Col} controlId="formEmail[]">
                    <Form.Label className="d-flex d-sm-none">Email</Form.Label>
                    <Form.Control type="email" required name="formEmail" placeholder="" value={inputField.email} onChange={event => handleInputChange('email', index, event)} />
                </Form.Group>
                </Col>
                <Col xs={12} sm={2} md={2} lg={2} className="d-flex justify-content-center">
                  <Form.Group as={Col} controlId="formContactRefereeAdd[]" className="segbutton">
                    <Form.Control type="button" className="add btn btn-outline-primary" value="+" onClick={() => addContactReferee(index)} />&nbsp;
                  </Form.Group>  
                  <Form.Group as={Col} controlId="formContactRefereeDel[]" className="segbutton">
                    <Form.Control type="button" className="del btn btn-outline-danger" value="-" onClick={() => delContactReferee(index)} />
                  </Form.Group>
                </Col>                         
            </Form.Row> 
            <hr className="d-flex d-sm-none" /> 
            </Fragment>
        ))}
        </>
        : <></> 

    );
}